import BookMenu from '@assets/icons/book-menu.svg'
import { Icon } from './Icon'

export const BookMenuIcon = Icon(BookMenu)
